import React from 'react';

export default function NotFound(props) {
  return <h2>
    404 Page Not Found
  </h2>
}
